import React from "react"

import styled from "styled-components"
import media from "styles/media"
import text from "styles/text"

import IconCheck from "images/IconCheck.png"
import ContentWidth from "./ContentWidth"

const StyledList = ({ content }) => {
  const pointStyle = content.points
  const allPoints = content.pointContent.map(point => (
    <PointContainer>
      {pointStyle === "checks" ? <Check src={IconCheck} /> : null}
      <Content>
        <TextContent dangerouslySetInnerHTML={{ __html: point.content }} />
      </Content>
    </PointContainer>
  ))

  return (
    <ContentWidth>
      <Wrapper>
        <Header>{content.header}</Header>
        <ListContainer>{allPoints}</ListContainer>
      </Wrapper>
    </ContentWidth>
  )
}

export default StyledList

const TextContent = styled.p`
  ${text.bodyMd};

  a {
    ${text.bodyMdBold};

    ${media.hover} {
      &:hover {
        text-decoration: underline;
      }
    }
  }
`
const Content = styled.div`
  display: flex;
  flex-direction: row;
  width: 36.389vw;

  ${media.fullWidth} {
    width: 524px;
  }

  ${media.tablet} {
    width: 43.164vw;
  }

  ${media.mobile} {
    width: 76vw;
  }
`
const Check = styled.img`
  width: 3.056vw;
  height: 3.056vw;

  ${media.fullWidth} {
    width: 44px;
    height: 44px;
  }

  ${media.tablet} {
    width: 4.297vw;
    height: 4.297vw;
  }

  ${media.mobile} {
    width: 7.477vw;
    height: 7.477vw;
  }
`
const PointContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1.111vw;
  padding: 1.25vw 0;

  ${media.fullWidth} {
    gap: 16px;
    padding: 18px 0;
  }

  ${media.tablet} {
    gap: 1.563vw;
    padding: 1.758vw 0;
  }

  ${media.mobile} {
    gap: 1.869vw;
    padding: 4.206vw 0;
  }
`
const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
`
const Header = styled.h2`
  ${text.h2};
  width: 33.889vw;

  ${media.fullWidth} {
    width: 488px;
  }

  ${media.tablet} {
    width: 47.656vw;
  }

  ${media.mobile} {
    width: 87.85vw;
  }
`
const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 4.583vw;
  padding: 0 4.167vw 0 7.431vw;

  ${media.fullWidth} {
    gap: 66px;
    padding: 0 60px 0 107px;
  }

  ${media.tablet} {
    gap: 5.078vw;
    padding: 0 5.859vw 0 10.449vw;
  }

  ${media.mobile} {
    flex-direction: column;
    padding: 0 6.075vw;
    gap: 18.692vw;
  }
`
